import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Sidebar from "./Sidebar";
import PartyScreen from "./PartyScreen";
import MasterScreen from "./MasterScreen";
import PurchaseScreen from "./PurchaseScreen";
import DeliveryScreen from "./DeliveryScreen";
import ProductionScreen from "./ProductionScreen";
import InvoiceScreen from "./InvoiceScreen";
import ReceiptScreen from "./ReceiptScreen";
import AllReports from "./AllReports";
import StockScreen from "./StockScreen";


import "./App.css";

function MainLayout() {
  const [page, setPage] = useState("PARTY LIST");
  const [history, setHistory] = useState([]);

  const handleSelect = (item) => {

    // 🔹 BACK button
    if (item === "BACK") {
      if (history.length > 0) {
        const previous = history[history.length - 1];
        setHistory(history.slice(0, -1));
        setPage(previous);
      }
      return;
    }

    // 🔹 EXIT button
    if (item === "EXIT") {
      const confirmExit = window.confirm("Are you sure you want to exit?");
      if (confirmExit) {
        window.close();              // works in desktop apps
        window.location.href = "/";  // fallback for browser
      }
      return;
    }

    // 🔹 Normal navigation
    setHistory(prev => [...prev, page]);
    setPage(item);
  };

  const renderPage = () => {
    switch (page) {
      case "PARTY LIST":
        return <PartyScreen />;
      case "MASTER":
        return <MasterScreen goHome={() => setPage("PARTY LIST")} />; 
      case "PURCHASE":
        return<PurchaseScreen goHome={() => setPage("PARTY LIST")} />;
      case "STOCK":
        return <StockScreen goHome={() => setPage("PARTY LIST")} />;
      case "DELIVERY":
        return <DeliveryScreen goHome={() => setPage("PARTY LIST")} />;
      case "INVOICE":
        return <InvoiceScreen goHome={() => setPage("PARTY LIST")} />;
      case "RECEIPT":
        return <ReceiptScreen goHome={() => setPage("PARTY LIST")} />;
      case "ALL REPORTS":
        return <AllReports goHome={() => setPage("PARTY LIST")} />;
      default:
        return <PartyScreen />;
    }
  };

 return (

  <div className="app-root">


{/* Desktop Header */}
<header className="brand">ORANGE TRADINGS</header>

{/* Sidebar */}
<Sidebar onSelect={handleSelect} />

{/* Main Screen */}
<div className="app-window">
  {renderPage()}
</div>


  </div>
);

    
  
}


function App() {
  return (
    <Router>
      <Routes>
        {/* Main App */}
        <Route path="/" element={<MainLayout />} />

      
      </Routes>
    </Router>
  );
}

export default App;
